const getProtocolColor = {
    methods: {
        getProtocolColor(protocol){
            return protocol === "cmp"
            ? "#487A7B"
            : protocol === "scep"
            ? "#C4622D"
            : protocol === "est"
            ? "#006CA1"
            : protocol === "acme"
            ? "#F1B300"
            : protocol === "its-s"
            ? "#861F41"
            : protocol === "acme/account"
            ? "#7B6469"
            : "";
        }
    }
};

export {getProtocolColor};